module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.scss
// module id = ./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.scss
// module chunks = 0